module.exports = __webpack_public_path__ + "static/media/beausite-classic-clear-semibold.269c4ce2.woff2";